<article class="cart-line">
  <img class="cart-line__image" [src]="line.merchandise.image.url" [alt]="line.merchandise.image.altText" />
  <main class="cart-line__main">
    <h2 class="h5 mb-0 mt-2">
      <span>{{ line.merchandise.product.title }}</span>
      <span class="float-right">
        {{ line.cost.totalAmount.amount | currency : line.cost.totalAmount.currencyCode : 'symbol' : '1.2-2' }}
      </span>
    </h2>
    <span class="type-body-xs d-block mb-2" *ngIf="line.merchandise?.sku">
      {{ 'winkelwagen-artikelnummer-label' | fromDictionary }} {{ line.merchandise.sku }}
    </span>
    <span class="type-body-sm d-block mb-2">{{ line.merchandise.product.productType }}</span>

    <span class="type-body-sm text-muted">
      <span class="cart-line__meta-option" [class.has--seperator]="line.merchandise.selectedOptions.length">
        <div class="amount-chooser mb-4 mb-sm-0">
          <button
            class="button button--secondary button-icon button--xs button-outline"
            (click)="changeQuantity(+line.quantity - 1, line.id)"
          >
            <app-icon anchor="icon-minus"></app-icon>
          </button>

          <div class="button button-outline button--secondary button--sm amount-chooser__amount">
            <input
              type="number"
              [formControl]="amountField"
              placeholder="aantal"
              (change)="changeQuantity(+(amountInput.value || 0), line.id)"
              #amountInput
            />

            <!-- <span class="chip me-2">{{ line.quantity }}</span>
            <span class="amount-chooser__suffix">{{ 'product-aantal-suffix' | fromDictionary }}</span> -->
          </div>

          <button
            class="button button--xs button-icon button--secondary"
            (click)="changeQuantity(+line.quantity + 1, line.id)"
            [disabled]="maxReached(line)"
            [title]="maxReached(line) ? ('winkelwagen-max-bereikt-waarschuwing' | fromDictionary) : 'add'"
          >
            <app-icon anchor="icon-plus"></app-icon>
          </button>
        </div>
        <ng-container *ngIf="line.merchandise.product.metafield as unit">{{ unit.value }}</ng-container>
      </span>

      <!-- <span
        *ngFor="let option of line.merchandise.selectedOptions; let i = index"
        class="cart-line__meta-option"
        [class.has--seperator]="i !== line.merchandise.selectedOptions.length - 1"
      >
        {{ option.value }}
      </span> -->
    </span>
  </main>
</article>
